"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-danger */
import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import { forwardRef } from "@chakra-ui/react";
import { useFileContent } from "../../../hooks/useFileContent";
import GenericSpriteSvg from "./GenericSpriteSvg";
const SvgSprite = forwardRef((props, ref) => {
    const { src } = props, otherProps = __rest(props, ["src"]);
    const spriteId = useMemo(() => uuidv4(), []);
    const svgSpriteFileContent = useFileContent({
        src,
        spriteId,
    });
    return (_jsxs(_Fragment, { children: [_jsx("div", { dangerouslySetInnerHTML: { __html: svgSpriteFileContent } }), _jsx(GenericSpriteSvg, Object.assign({ ref: ref, src: "", spriteId: spriteId }, otherProps))] }));
});
export default SvgSprite;
//# sourceMappingURL=SvgSprite.js.map